import { useCallback, useMemo } from 'react';

import { DEFAULT_PAGE_SIZE } from '@/lib/constants/pagination';
import { getClients } from '@/modules/onboarding/clients-setup/api/clients';

export const useClientSelectLoaders = () => {
  const loadItems = useCallback(async (cursor?: number | null) => {
    const response = await getClients({ cursor: cursor ?? undefined, pageSize: DEFAULT_PAGE_SIZE });
    return {
      items: response.items.map(client => ({ id: client.id.toString(), name: client.name })),
      pagination: response.pagination,
    };
  }, []);

  const searchItems = useCallback(async (searchTerm: string, cursor?: number | null) => {
    const response = await getClients({
      searchString: searchTerm,
      cursor: cursor ?? undefined,
      pageSize: DEFAULT_PAGE_SIZE,
    });
    return {
      items: response.items.map(client => ({ id: client.id.toString(), name: client.name })),
      pagination: response.pagination,
    };
  }, []);

  return useMemo(() => ({ loadItems, searchItems }), [loadItems, searchItems]);
};
